(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDialogController', CareTeamSpecialtyDialogController);

    CareTeamSpecialtyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CareTeamSpecialty', 'CareTeam', 'Corporation'];

    function CareTeamSpecialtyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CareTeamSpecialty, CareTeam, Corporation) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.careTeamSpecialty.id !== null) {
                CareTeamSpecialty.update(vm.careTeamSpecialty, onSaveSuccess, onSaveError);
            } else {
                CareTeamSpecialty.save(vm.careTeamSpecialty, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:careTeamSpecialtyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
